import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadTeamEvents } from "../pages/wallPlanner.duck";
import { selectCalendarDate } from "@shared/store/dashboard.duck";
import { selectFollowingTeams } from '@features/whereabouts/store/followingTeamsAndTags.duck';
import { DATE_FORMAT } from "@shared/utils/DateUtils";
import { TeamEntity } from '@shared/models/team.models';

// Loads team events for the visible period. Defaults to the user's followed
// teams; pass `teams` to load an explicit set instead (used by whereabouts
// pages pinned to one team).
export function WithWorkPlannerTeamEvents(teams?: TeamEntity[]) {
  const dispatch = useDispatch();
  const followedTeams = useSelector(selectFollowingTeams);
  const calendarDate = useSelector(selectCalendarDate);
  const calendarDateString = calendarDate?.format(DATE_FORMAT);
  const teamsToLoad = teams ?? followedTeams;

  useEffect(() => {
    const id = setTimeout(() => {
      teamsToLoad.forEach((team) => dispatch(loadTeamEvents({date: calendarDateString, teamId: team?.id})))
    }, 250);

    return () => {
      clearTimeout(id);
    }
  }, [dispatch, teamsToLoad, calendarDateString]);
}
